// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @30.07.2019 15:26:36
import * as SagaBase from '../../../SagaBase';
import { QueryValueElement } from '../../../SagaBase/Objects/QueryValueElement';
import { Guid, GuidTools } from '@models/guid';

export abstract class OperandFunction_abstract extends QueryValueElement {
  static $t: string = 'SagaBase.Objects.OperandFunction';
  $t: string = 'SagaBase.Objects.OperandFunction';

  public static GetMembers(): string[] {
    return [].concat(QueryValueElement.GetMembers());
  }

  public GetMembers(): string[] {
    return OperandFunction_abstract.GetMembers();
  }

  public _init(): void {
    super._init();
    //// Add "NO-" before "AUTO_INIT_CODE" if don't want to re-generate at each compilation
    ///*<AUTO_INIT_CODE>*/

    ///*</AUTO_INIT_CODE>*/
  }

  // Add "NO-" before "INSTANCE_MEMBERS" if don't want to re-generate at each compilation
  /*<INSTANCE_MEMBERS>*/

  /*</INSTANCE_MEMBERS>*/

  // Add "NO-" before "AUTO_IMPLEMENTATION" if don't want to re-generate at each compilation
  /*<AUTO_IMPLEMENTATION>*/

  /*</AUTO_IMPLEMENTATION>*/
}
